import { render, staticRenderFns } from "./nav_pc.vue?vue&type=template&id=6329f9f8&scoped=true"
import script from "./nav_pc.vue?vue&type=script&lang=js"
export * from "./nav_pc.vue?vue&type=script&lang=js"
import style0 from "./nav_pc.vue?vue&type=style&index=0&id=6329f9f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6329f9f8",
  null
  
)

export default component.exports